import React from 'react';
import numeral from 'numeral';

import api from '../../utils/api';

import '../../styles/projects/Usage.css';


class Usage extends React.Component {

    apiCall = null;

    state = {
        usage: null
    };

    componentDidMount() {

        if (this.props.project && this.props.project.userId === this.props.user.uid) {

            this.apiCall = api.getUsage({ projectId: this.props.project.id }).then(({ data: usage }) => {

                this.setState({ usage });
            });
        }
    }

    componentWillUnmount() {

        api.cancel(this.apiCall);
    }

    render() {

        if (!this.state.usage) {
            return <div/>;
        }

        const bandwidth = this.state.usage.bandwidth.data[0];
        const volume = this.state.usage.volume.data[0];

        return (
            <div className="usage">
                <h5>
                            <span className="label label-default">
                                {bandwidth ? numeral(bandwidth.total_usage).format('0b') : 0}
                                </span> Bandwidth
                </h5>
                <h5>
                            <span className="label label-default">
                                {volume ? numeral(volume.total_usage).format('0a') : 0}
                                </span> Comments
                </h5>
                <sub>Updated hourly</sub>
            </div>
        );
    }
}

export default Usage;


// WEBPACK FOOTER //
// ./src/components/projects/Usage.jsx